"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatahubCertificateService = void 0;
var datahubCertificateService_1 = require("./datahubCertificateService");
Object.defineProperty(exports, "DatahubCertificateService", { enumerable: true, get: function () { return __importDefault(datahubCertificateService_1).default; } });
